import { COMPANY_EMAIL } from '../contact/COMPANY_EMAIL';

/**
 * @group Legal
@summary <blockquote>Legal and privacy contact endpoints for end-users and regulators.</blockquote>
 * @internal
 */
export const LEGAL_CONTACTS = {
  privacyEmail: COMPANY_EMAIL, // Primary privacy contact
  dataProtectionOfficerEmail: 'info@phila.life',
  physicalAddress: `Boulevard Place
Heron Crescent\n
Century City\n
7441\n
Cape Town\n
South Africa`,
  regulatoryContacts: {
    southAfrica: {
      informationRegulatorEmail: 'enquiries@inforegulator.org.za',
      informationRegulatorPhone: '+27 10 023 5200'
    }
  }
} as const;


